import { render, staticRenderFns } from "./CategoriesHorizontalFilter.vue?vue&type=template&id=d61d6d66&scoped=true&"
import script from "./CategoriesHorizontalFilter.vue?vue&type=script&lang=js&"
export * from "./CategoriesHorizontalFilter.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesHorizontalFilter.vue?vue&type=style&index=0&id=d61d6d66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d6d66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
